export enum ColumnSize {
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
    FIVE = 5,
}

export enum GridBlockType {
    SHOWSTOPPER = 'showstopper',
    PLUS_CAMPAIGN = 'plus_campaign',
    NEW_DEALS_CAROUSEL = 'new_deals_carousel',
    CONTINUE_SHOPPING = 'continue_shopping',
}

export enum GridBlockId {
    PLUS_EXCLUSIVE_CAMPAIGN = 'plus_exclusive_campaign',
    PLUS_CAMPAIGN_CARD = 'plus_campaign_card',
    SHOWSTOPPER = 'Showstopper',
    SHOWSTOPPER_1 = 'Showstopper_1',
    SHOWSTOPPER_2 = 'Showstopper_2',
    NEW_DEALS_CAROUSEL = 'new_deals_carousel',
    CONTINUE_SHOPPING_SHOWSTOPPER = 'continue_shopping_showstopper',
}

export interface GridBlock {
    id?: GridBlockId;
    type?: GridBlockType;
    x: number;
    y: number;
    w: number;
    h: number;
}

export interface Grid {
    [ColumnSize.ONE]: GridBlock[];
    [ColumnSize.TWO]: GridBlock[];
    [ColumnSize.THREE]: GridBlock[];
    [ColumnSize.FOUR]: GridBlock[];
    [ColumnSize.FIVE]?: GridBlock[];
}
